import mapboxgl from "mapbox-gl";

let initialized = false;

export function initMapboxRTLOnce() {
  if (initialized) return;
  initialized = true;
  try {
    mapboxgl.setRTLTextPlugin(
      "https://api.mapbox.com/mapbox-gl-js/plugins/mapbox-gl-rtl-text/v0.3.0/mapbox-gl-rtl-text.min.js",
      () => {},
      true
    );
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error("RTL text plugin failed to initialize:", error);
  }
}
